import {
  MainHeader,
  MainTitle,
  MainSubTitle,
  OptionLabel,
} from "@/pages/styled";

const CustomerHeader = ({ title, subTitle, description }) => {
  return (
    <MainHeader>
      <div>
        <MainTitle>{title}</MainTitle>
        {subTitle && <MainSubTitle>{subTitle}</MainSubTitle>}
        {description && (
          <OptionLabel style={{ width: "100%", maxWidth: 550 }}>
            {description}
          </OptionLabel>
        )}
      </div>
    </MainHeader>
  );
};

export default CustomerHeader;
